import { Grid, Stack } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { TSDViewHouseFormValues } from '@e-origin/contracts';

import { TextInput } from '@components';

interface HouseCoreDataProps {
  houseForm: UseFormReturnType<TSDViewHouseFormValues>;
  disabled: boolean;
}

export const HouseCoreData: React.FC<HouseCoreDataProps> = ({ houseForm, disabled }) => {
  return (
    <Stack mt="md">
      <Grid>
        <Grid.Col span={4}>
          <TextInput
            {...houseForm.getInputProps('referenceNumberUCR')}
            name="referenceNumberUCR"
            disabled={disabled}
            label="Reference Number UCR"
            data-pw="reference-number-ucr-input"
          />
        </Grid.Col>
        <Grid.Col span={3}>
          <TextInput {...houseForm.getInputProps('totalGrossMass')} label="Total Gross Mass" disabled={disabled} data-pw="total-gross-mass-input" />
        </Grid.Col>
        <Grid.Col span={4}>
          <TextInput
            {...houseForm.getInputProps('totalNumberOfPackages')}
            label="Total Number of Packages"
            disabled={disabled}
            data-pw="total-number-of-packages-input"
          />
        </Grid.Col>
      </Grid>
    </Stack>
  );
};
